/* eslint-disable @next/next/no-head-element */
/* eslint-disable @next/next/no-page-custom-font */
import { ReactNode } from 'react';
import { jetBrainsMono } from '@/components/kg/fonts';
import { SessionProvider } from 'next-auth/react';

import HeaderKG from '../HeaderKG';
import SkipLink, { MAIN_CONTENT_ID } from '@/components/common/skip-link';
import FooterKG from '../FooterKG';

import '../../../app/globals.css';
import './DefaultLayoutKG.css';

interface LayoutProps {
  children: ReactNode;
}

const DefaultLayoutKG = async ({ children }: LayoutProps) => {
  return (
    <html lang="en" className={jetBrainsMono.variable}>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body className="body-kg">
        <SessionProvider session={null}>
          <link rel="shortcut icon" href="/kg/favicon.ico" />
          <div className="h-full flex flex-col justify-between">
            <div>
              <SkipLink />
              <HeaderKG />
              <main id={MAIN_CONTENT_ID} tabIndex={-1} className="outline-none">
                {children}
              </main>
            </div>
            <div>
              <FooterKG isAuthorized={false} />
            </div>
          </div>
        </SessionProvider>
      </body>
    </html>
  );
};

export default DefaultLayoutKG;
